/**
 * Price per license after a percent discount, rounded half-up to the cent.
 * Integer-cent math so it always matches the backend (org_service._quote),
 * which stores and charges exactly this number.
 */
export function seatPrice(unitPrice, pctOff) {
    const cents = Math.round(Number(unitPrice || 0) * 100);
    const pct = Math.round(Number(pctOff || 0) * 10000); // percent stored with 4 decimals
    return Math.floor((cents * (1000000 - pct) + 500000) / 1000000) / 100;
}

/** Total for `qty` licenses at `each` dollars, in whole cents. */
export function seatTotal(each, qty) {
    return (Math.round(Number(each) * 100) * qty) / 100;
}
